import useDyspozycjaForm from '../../common/hooks/useDyspozycjaForm'

export default function useDyspozycjaAdd() {
	return useDyspozycjaForm('add')
}
